import tweetme from '../../../assets/images/projects_images/tweetme.PNG'
import chatapp from '../../../assets/images/projects_images/chatapp.JPG'
import hardware_store from '../../../assets/images/projects_images/hardware_store.jpg'
import portfolio from '../../../assets/images/projects_images/portfolio.JPG'
import new_year from '../../../assets/images/projects_images/new_year.jpg'
import color_classification from '../../../assets/images/projects_images/color_classification.jpg'
import blinking from '../../../assets/images/projects_images/blinking.JPG'
import COVID from '../../../assets/images/projects_images/COVID.jpg'
import Dev_talks from '../../../assets/images/projects_images/Dev_talks.jpg'

const data_blogs = [
    //{
    //    name: 'COVID 19 tracker',
    //    image: COVID,
    //    published_url: 'https://covid-19-tracker-by-sumit.web.app/',
    //    description: "Ex audire suavitate has, ei quodsi tacimates sapientem sed, pri zril ubique ut. Te cule tation munere noluisse. Enim torquatos…",
    //    published_date: 'April 23, 2021',
    //    category: ['react.js']
    //},

    //{
    //    name: 'Dev Talks',
    //    image: Dev_talks,
    //    published_url: 'https://dev-talks.herokuapp.com/',
    //    description: "Ex audire suavitate has, ei quodsi tacimates sapientem sed, pri zril ubique ut. Te cule tation munere noluisse. Enim torquatos…",
    //    published_date: 'April 23, 2021',
    //    category: ['node.js', 'mongoDB', 'react.js']
    //},

    //{
    //    name: 'Realtime Chat App',
    //    image: chatapp,
    //    published_url: 'https://sumit-chat.netlify.app/',
    //    description: "Ex audire suavitate has, ei quodsi tacimates sapientem sed, pri zril ubique ut. Te cule tation munere noluisse. Enim torquatos…",
    //    published_date: 'April 23, 2021',
    //    category: ['node', 'socket.io', 'react']
    //},

    //{
    //    name: 'Tweeter Clone',
    //    image: tweetme,
    //    published_url: 'http://sumaxtweetme.pythonanywhere.com/',
    //    description: "Ex audire suavitate has, ei quodsi tacimates sapientem sed, pri zril ubique ut. Te cule tation munere noluisse. Enim torquatos…",
    //    published_date: 'April 23, 2021',
    //    category: ['django', 'react']
    //},

    //{
    //    name: 'Shop Website',
    //    image: hardware_store,
    //    published_url: '!#',
    //    published_date: 'April 23, 2021',
    //    description: "Ex audire suavitate has, ei quodsi tacimates sapientem sed, pri zril ubique ut. Te cule tation munere noluisse. Enim torquatos…",
    //    category: ['html_css', 'vanilla']
    //},

    //{
    //    name: 'Dev Portfolio',
    //    image: portfolio,
    //    description: "Ex audire suavitate has, ei quodsi tacimates sapientem sed, pri zril ubique ut. Te cule tation munere noluisse. Enim torquatos…",
    //    published_url: 'http://suprateem.herokuapp.com/',
    //    published_date: 'April 23, 2021',
    //    category: ['vanilla']
    //},

    //{
    //    name: 'Bengali New Year',
    //    image: new_year,
    //    description: "Ex audire suavitate has, ei quodsi tacimates sapientem sed, pri zril ubique ut. Te cule tation munere noluisse. Enim torquatos…",
    //    published_url: 'https://dey-sumit.github.io/NewYear/',
    //    published_date: 'April 23, 2021',
    //    category: ['vanilla']
    //},

    //{
    //    name: 'Color Classification using tf.js',
    //    image: color_classification,
    //    published_url: '!#',
    //    description: "Ex audire suavitate has, ei quodsi tacimates sapientem sed, pri zril ubique ut. Te cule tation munere noluisse. Enim torquatos…",
    //    published_date: 'April 23, 2021',
    //    category: ['node', 'machine_learning']
    //},
    //{
    //    name: 'Blinking bubbles',
    //    image: blinking,
    //    description: "Ex audire suavitate has, ei quodsi tacimates sapientem sed, pri zril ubique ut. Te cule tation munere noluisse. Enim torquatos…",
    //    published_url: 'https://dey-sumit.github.io/Blinking_Bubbles/',
    //    published_date:'April 23, 2021',
    //    category: ['processing']
    //}
]

export default data_blogs;